import React from 'react';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import Container from '@material-ui/core/Container';
import Typography from '@material-ui/core/Typography';
import Hidden from '@material-ui/core/Hidden';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { coursePropTypes } from '@anu/utilities/transform.course';
import { getPwaSettings } from '@anu/utilities/settings';
import DownloadCoursePopup from '@anu/components/DownloadCoursePopup';
import LinearProgressWithStatus
  from '../../components/LinearProgressWithStatus';

const useStyles = makeStyles((theme) => ({
  wrapper: {
    [theme.breakpoints.up('md')]: {
      borderBottom: '1px solid ' + theme.palette.grey[300],
    },
  },
  container: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  title: {
    maxWidth: 680,
    paddingRight: theme.spacing(2),
    '@media print': {
      fontSize: theme.typography.h1.fontSize,
      marginTop: theme.spacing(4),
    }
  },
  label: {
    borderRadius: '4px',
    padding: theme.spacing(1, 1.5),
    background: theme.palette.grey[200],
    ...theme.typography.label2,
    marginRight: theme.spacing(1),
  },
  actions: {
    display: 'flex',
    [theme.breakpoints.up('md')]: {
      justifyContent: 'flex-end',
    },
    '@media print': {
      display: 'none',
    }
  },
}));

const LessonHeader = ({ course }) => {
  const classes = useStyles();
  const statusLabel = course.progress_percent === 100
    ? Drupal.t('Completed')
    : Drupal.t('Progress');

  return (
    <Box pt={[2, 3]} pb={[2, 3]} className={classes.wrapper}>
      <Container maxWidth={false}>
        <Grid className={classes.container}>
          <Grid container alignItems="center" wrap="wrap">
            {course && course.title && (
              <Typography variant="h5" component="h1" className={classes.title}>
                {course.title}
              </Typography>
            )}
            {course && getPwaSettings() && (
              <Hidden smDown>
                <Box mx={-1} mt={0.5}>
                  <DownloadCoursePopup course={course} showButton={true} />
                </Box>
              </Hidden>
            )}
            {course &&
              course.labels.map((label) => (
                <Grid item key={label}>
                  <Box className={classes.label}>{label}</Box>
                </Grid>
              ))}
          </Grid>

          <Grid className={classes.actions} data-html2pdf-ignore>
            {course.track_progress
              && <LinearProgressWithStatus status={statusLabel} value={course.progress_percent} />}
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

LessonHeader.propTypes = {
  course: coursePropTypes,
};

LessonHeader.defaultProps = {
  course: null,
};

export default LessonHeader;
